'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["responsive", "stickyHeader"];
import React, { useState } from 'react';
import { Container } from "./TableContainer.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
export var TableContainer = function TableContainer(_ref) {
  var responsive = _ref.responsive,
    stickyHeader = _ref.stickyHeader,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0],
    setSticky = _useState2[1];
  return /*#__PURE__*/React.createElement(Container, Object.assign({
    $responsive: responsive,
    $stickyHeader: stickyHeader,
    onScroll: function onScroll(e) {
      return setSticky(e.target instanceof HTMLElement && e.target.scrollTop !== 0);
    },
    $isSticky: isSticky
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.TableContainer
  }));
};